import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'tc-page-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.css',
})
export class PageHeaderComponent {
  title = input.required<string>();
  subtitle = input<string>('');
}
